// extracted by mini-css-extract-plugin
module.exports = {"hover-trigger":"NavItem_hover-trigger__1MY0i","hover-target":"NavItem_hover-target__193oJ","item-bubble":"NavItem_item-bubble__3Pt1M"};